import React, { useState } from 'react';
import { Admin } from '../types';
import { Icons } from '@/icons';
// import { MENU_MAP, MenuDescriptor } from './MenuMap';
import GamicsDialog from '@/components/dialog/GamicsDialog';
interface Props {
  admin: Admin;
  setUserData: (admin: Admin)=> void;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const DATE_FORMATTER = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
});

const LAST_ACTIVITY_UNITS = [
  { label: 'year', ms: 1000 * 60 * 60 * 24 * 365 },
  { label: 'month', ms: 1000 * 60 * 60 * 24 * 30 },
  { label: 'day', ms: 1000 * 60 * 60 * 24 },
  { label: 'hour', ms: 1000 * 60 * 60 },
  { label: 'minute', ms: 1000 * 60 },
  { label: 'second', ms: 1000 },
] as const;

const formatRelativeTime = (diffMs: number) => {
  if (diffMs < 1000) return 'just now';
  for (const unit of LAST_ACTIVITY_UNITS) {
    if (diffMs >= unit.ms) {
      const count = Math.floor(diffMs / unit.ms);
      return `${count} ${unit.label}${count === 1 ? '' : 's'} ago`;
    }
  }
  return 'just now';
};

const getLastActivityInfo = (timestamp?: string | null) => {
  if (!timestamp) {
    return { label: 'No activity yet', relative: '' };
  }
  const parsed = Date.parse(timestamp);
  if (Number.isNaN(parsed)) {
    return { label: timestamp, relative: '' };
  }
  const formatted = DATE_FORMATTER.format(parsed);
  const diffMs = Date.now() - parsed;
  if (diffMs < 0) {
    return { label: formatted, relative: 'in the future' };
  }
  return { label: formatted, relative: formatRelativeTime(diffMs) };
};

const RoleRow: React.FC<Props> = ({ admin, setIsOpen, setUserData }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogType, setDialogType] = useState<
    'removed' | 'approved' | 'rejected' | 'hold' | null
  >(null);
  const lastActivity = getLastActivityInfo(admin.lastPermissionActivity);

  return (
    <>
      <tr className='border-b'>
        <td className='p-4'>{admin.name}</td>
        <td className='p-4'>{admin.email}</td>
        <td className='p-4'>{admin.role}</td>
        <td className='p-4'>
          <div className='flex flex-col gap-1'>
            <span className='text-sm font-medium text-slate-900'>
              {lastActivity.label}
            </span>
            {lastActivity.relative && (
              <span className='text-xs text-slate-500'>
                {lastActivity.relative}
              </span>
            )}
          </div>
        </td>
        <td className='p-4'>
          {Array.isArray(admin.permission)
            ? admin.permission.map((p) => p.key).join(', ')
            : ''}
        </td>
        <td className='p-4 relative'>
          <Icons.Edit onClick={() => {setIsOpen(true); setUserData(admin)}} />
        </td>
      </tr>

      <GamicsDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        type={dialogType!}
      />
    </>
  );
};

export default RoleRow;
